import React from "react"

import { Context } from "../../utility/context"

class Menu extends React.Component {
	state = {
		showHistoryMenu: false,
	}

	toggleHistoryMenu = () => {
		this.setState({showHistoryMenu: !this.state.showHistoryMenu});
	}

	render() {
		return (
			<div className="col col-12 bg-mercer-black fg-mercer-white py1 px3 line-height-1 flex">
				<div className="pr2 pointer relative" onClick={()=> this.toggleHistoryMenu()}>
					<span className={`mr1 inline-block ${this.state.showHistoryMenu? "rotated-90" : ""}`}>&#8227;</span>
					<small>History</small>
				  <Context.Consumer>
				    {context => (
							<div className={`absolute bg-mercer-black ${this.state.showHistoryMenu? "" : "display-none"}`} style={{width:"170%", zIndex:20}}>
								<ul className="no-list-style py1 px2 m0">
									{context.navigationLinks.map((navigationLink, index) => (
										<li key={index} className="pointer mb1">
											<a className={`fg-mercer-white`} target="_parent" href={navigationLink.link}>
												<small>{navigationLink.menu}</small>
											</a>
										</li>
									))}
								</ul>
							</div>
						)}
					</Context.Consumer>
				</div>
				<div className="pr2 pointer">
					<span className="mr1 inline-block">&#8227;</span>
					<small>Methodology & Definitions</small>
				</div>
			</div>
		)
	}
}

export default Menu
